module.exports = __webpack_public_path__ + "img/pic_huishou.fc7dfc9d.png";